import { gql } from '@apollo/client';

export const InstrumentsQuery = gql`
    query Instruments {
        instruments {
            code
            subInstruments {
                code
            }
        }
    }
`;

export const GenresQuery = gql`
    query Genres {
        genres {
            code
            subGenres {
                code
            }
        }
    }
`;

export const SfxsQuery = gql`
    query Sfxs {
        sfxs {
            code
            subSfxs {
                code
            }
        }
    }
`;

export const GetFilters = gql`
    query Filters {
        instruments {
            code
            subInstruments {
                code
            }
        }
        genres {
            code
            subGenres {
                code
            }
        }
        sfxs {
            code
            subSfxs {
                code
            }
        }
        tags {
            code
            displayName
        }
    }
`;
